import { ReactComponent as ErrorPage } from "../../assets/icons/error-page.svg";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import store from "store/store";
import { clearErrorCode } from "store/actions/errorStatus";
import NewButton, {
  NewButtonVariant,
} from "components/common/buttons/basicButton/NewButton";

const NotFoundPage = () => {
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div
        className="rounded-sm shadow-xl rounded-2xl  max-w-md w-full text-center px-36 pt-18 pb-12"
        style={{
          background: "oklch(70.4% 0.04 256.788)",
        }}
      >
        <div className="flex justify-center mb-6">
          <ErrorPage className="h-16 w-16 text-red-500 drop-shadow animate-pulse" />
        </div>

        <p className="text-gray-600 mb-6 font-medium">
          {t("common.pageNotFound")}
          <div></div>
          {t("common.checkUrl")}
        </p>
        <div className="p-12">
          <NewButton
            variant={NewButtonVariant.Primary}
            onClick={() => {
              store.dispatch(clearErrorCode());
              history.push("/");
            }}
            fullWidth
          >
            {t("common.goHome")}
          </NewButton>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
